// extracted by mini-css-extract-plugin
export default {"image":"styles_image__E+IJE","label":"styles_label__nwOZp"};